export type SearchFormPrice = Pick<SearchFilters, 'min_price' | 'max_price' | 'discount_early' | 'discount_weekly'>
export const useSearchFiltersPricesForm = (formRef: Ref<SearchFormPrice> | undefined = undefined) => {
  const { filters } = storeToRefs(useSearchStore())

  const PRICE_RANGE = { MIN: 0, MAX: 500 } as const

  const formPrices = formRef === undefined
    ? ref<SearchFormPrice>({
        min_price: null,
        max_price: null,
        discount_early: false,
        discount_weekly: false,
      })
    : formRef

  const initFormPrices = () => {
    formPrices.value.min_price = filters.value.min_price
    formPrices.value.max_price = filters.value.max_price
    formPrices.value.discount_early = filters.value.discount_early
    formPrices.value.discount_weekly = filters.value.discount_weekly
  }

  const coercedMinPrice = computed({
    get() {
      return formPrices.value.min_price || PRICE_RANGE.MIN
    },
    set(value) {
      formPrices.value.min_price = value
    },
  })
  const coercedMaxPrice = computed({
    get() {
      return formPrices.value.max_price || PRICE_RANGE.MAX
    },
    set(value) {
      formPrices.value.max_price = value
    },
  })

  const priceRange = computed({
    get: (): [number, number] => {
      return [coercedMinPrice.value, coercedMaxPrice.value]
    },
    set: ([minPrice, maxPrice]: [number | string, number | string]) => {
      coercedMaxPrice.value = typeof maxPrice === 'number' ? maxPrice : parseInt(maxPrice)
      coercedMinPrice.value = typeof minPrice === 'number' ? minPrice : parseInt(minPrice)
    },
  })

  return {
    formPrices,
    initFormPrices,
    PRICE_RANGE,
    coercedMinPrice,
    coercedMaxPrice,
    priceRange,
  }
}
